import { type ValueOf } from '../types';

export const ApplicationAccess = {
  VeraRepair: 'VeraRepair',
  VeraSyndicus: 'VeraSyndicus',
} as const;

export type ApplicationAccess = ValueOf<typeof ApplicationAccess>;

export default ApplicationAccess;
